const modelName = 'Contact Requests';
const modelNameSingular = 'Contact Request';
const endpoint = 'contact-requests';

const setup = {
  endpoint,
  title: modelName,
  singular: modelNameSingular,
  model: modelName.replace(/\s+/g, '-').toLowerCase(),
  canDelete: false,
  canAddNew: false,
  canSearch: true
};

export { setup };
